import services from 'services/module';
import { AuthenticationSvc } from './AuthenticationSvc';

function UserChangeWatcherSvc(
    this: any,
    $interval: ng.IIntervalService,
    $timeout: ng.ITimeoutService,
    $log: ng.ILogService,
    ipCookie: ipCookie,
    AuthenticationSvc: AuthenticationSvc
) {
    let checkInterval = 3000;

    const userTracker = _.once(() => {
        $timeout(() => {
            let tokenFromCookie: string = ipCookie(
                AuthenticationSvc.animatronCookieName
            );
            let inProgress = false;

            $interval(() => {
                if (!inProgress) {
                    tokenFromCookie = ipCookie(
                        AuthenticationSvc.animatronCookieName
                    );

                    const isCookieTokenChanged =
                        AuthenticationSvc.loggedIn &&
                        tokenFromCookie !== options.user.hash;

                    const isUserNotLogInYet =
                        !AuthenticationSvc.loggedIn && tokenFromCookie;

                    const isUserNotLogOutYet =
                        AuthenticationSvc.loggedIn && !tokenFromCookie;

                    if (isUserNotLogOutYet) {
                        $log.debug('User logged out.');
                        inProgress = true;
                        AuthenticationSvc.logoutAndGoRoot().then(
                            () => (inProgress = false)
                        );
                    } else if (isUserNotLogInYet || isCookieTokenChanged) {
                        $log.debug('User logged in.');
                        inProgress = true;
                        AuthenticationSvc.loginFromCookie().then(
                            () => (inProgress = false)
                        );
                    }
                }
            }, checkInterval);
        }, checkInterval);
    });

    this.init = _.once((callback: any) => {
        if (AuthenticationSvc.isCookieEnabled()) {
            AuthenticationSvc.getUser(true)
                .then(callback)
                .then(userTracker);
        } else {
            AuthenticationSvc.setAnonymous().then(() => {
                callback();
                _.notification.showError(
                    'Oh no! It seems you have disabled cookies! To continue please enable cookies in your browser and refresh the page.',
                    0
                );
            });
        }
    });
}

services.service('UserChangeWatcherSvc', UserChangeWatcherSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/UserChangeWatcherSvc.ts